import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';

import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
// import ProductDetailsPage
// from './pages/ProductDetailsPage';

import HomePage from './pages/HomePage';
import ProductPage from './pages/ProductPage';
import CategoriesPage from './pages/CategoriesPage';
import HelpPage from './pages/HelpPage';
import ProductDetailsPage from './pages/ProductDetailsPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import CategoryProductsPage from './pages/CategoryProductsPage';
import CartPage from './pages/CartPage';
import WishlistPage from './pages/WishlistPage';
import CheckoutPage from './pages/CheckoutPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailsPage from './pages/OrderDetailsPage';
import ProfilePage from './pages/ProfilePage';
import AdminDashboard from './pages/AdminDashboard';
import AdminProductsPage from './pages/AdminProductsPage';
import AddProductPage from './pages/AddProductPage';
import AdminOrdersPage from './pages/AdminOrdersPage';
import AdminUsersPage from './pages/AdminUsersPage';
import EditProductPage from './pages/EditProductPage';
import AdminCategoriesPage from './pages/AdminCategoriesPage';
import AdminCategoryProductsPage from './pages/AdminCategoryProductsPage';
import AdminCouponsPage from './pages/AdminCouponsPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import VerifyOtpPage from './pages/VerifyOtpPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import AdminTicketsPage from './pages/AdminTicketsPage';
import AdminTicketDetailsPage from './pages/AdminTicketDetailsPage';
import MyTicketsPage from './pages/MyTicketsPage';
import TicketDetailsPage from './pages/TicketDetailsPage';
import AdminRefundsPage from './pages/AdminRefundsPage';
import AdminReviewsPage from './pages/AdminReviewsPage';
import MyRefundsPage from './pages/MyRefundsPage';
import ApplyRefundPage from './pages/ApplyRefundPage';
import AdminRoute from './components/AdminRoute';
import AdminProductTimePage from './pages/AdminProductTimePage';
import { claimGuestHistory } from './utils/productTracking';
import ChatBot from './components/ChatBot';
import AssistantLauncher from './components/AssistantLauncher';
import AssistantPage from './pages/AssistantPage';
import Footer from './components/Footer';
import DeliveryRoute from './components/DeliveryRoute';
import DeliveryLoginPage from './pages/DeliveryLoginPage';
import DeliverySignupPage from './pages/DeliverySignupPage';
import DeliveryDashboard from './pages/DeliveryDashboard';
import AdminDeliveryPartnersPage from './pages/AdminDeliveryPartnersPage';
import MobileBottomNav from './components/MobileBottomNav';
import NotificationLauncher from './components/NotificationLauncher';
import MobileFabDial from './components/MobileFabDial';
import BackgroundMusic from './components/BackgroundMusic';
import GlobalBackground from './components/GlobalBackground';
// import HelpPage from './pages/HelpPage';

function App() {
  /*
    Attribute any leftover guest browsing in this browser to the logged-in
    user. Covers users who were already logged in before this feature
    existed (they never re-hit the login-time claim).
  */
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');

    if (userInfo?._id) {
      claimGuestHistory(userInfo._id);
    }
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <GlobalBackground />
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh'
        }}
      >
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"
        />

        <main style={{ flex: 1 }}>
          <Routes>
        <Route path="/" element={<HomePage />} />

        <Route path="/products" element={<ProductPage />} />

        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/assistant" element={<AssistantPage />} />
        <Route
          path="/admin/edit-product/:id"
          element={
            <AdminRoute>
              <EditProductPage />
            </AdminRoute>
          }
        />
        <Route path="/category/:category" element={<CategoryProductsPage />} />

        <Route path="/help" element={<HelpPage />} />
        <Route path="/product/:id" element={<ProductDetailsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/checkout" element={<CheckoutPage />} />

        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/admin/orders"
          element={
            <AdminRoute>
              <AdminOrdersPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <AdminRoute>
              <AdminUsersPage />
            </AdminRoute>
          }
        />

        <Route path="/signup" element={<SignupPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/order/:orderId" element={<OrderDetailsPage />} />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/products"
          element={
            <AdminRoute>
              <AdminProductsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/categories"
          element={
            <AdminRoute>
              <AdminCategoriesPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/category-products/:category"
          element={
            <AdminRoute>
              <AdminCategoryProductsPage />
            </AdminRoute>
          }
        />

        <Route
          path="/admin/add-product"
          element={
            <AdminRoute>
              <AddProductPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/coupons"
          element={
            <AdminRoute>
              <AdminCouponsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/tickets"
          element={
            <AdminRoute>
              <AdminTicketsPage />
            </AdminRoute>
          }
        />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />

        <Route path="/verify-otp" element={<VerifyOtpPage />} />
        <Route path="/my-tickets" element={<MyTicketsPage />} />

        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/admin/tickets/:id"
          element={
            <AdminRoute>
              <AdminTicketDetailsPage />
            </AdminRoute>
          }
        />
        <Route path="/ticket/:id" element={<TicketDetailsPage />} />
        <Route
          path="/admin/refunds"
          element={
            <AdminRoute>
              <AdminRefundsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/reviews"
          element={
            <AdminRoute>
              <AdminReviewsPage />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/product-time"
          element={
            <AdminRoute>
              <AdminProductTimePage />
            </AdminRoute>
          }
        />
        <Route
          path="/my-refunds"

          element={<MyRefundsPage />}
        />

        {/* Refund application — order picker, then the form for one order */}
        <Route path="/apply-refund" element={<ApplyRefundPage />} />
        <Route path="/apply-refund/:orderId" element={<ApplyRefundPage />} />

        {/* Delivery partner portal */}
        <Route path="/delivery/login" element={<DeliveryLoginPage />} />
        <Route path="/delivery/signup" element={<DeliverySignupPage />} />
        <Route
          path="/delivery"
          element={
            <DeliveryRoute>
              <DeliveryDashboard />
            </DeliveryRoute>
          }
        />
        <Route
          path="/admin/delivery-partners"
          element={
            <AdminRoute>
              <AdminDeliveryPartnersPage />
            </AdminRoute>
          }
        />
          </Routes>
        </main>

        <Footer />

        <FloatingWidgets />

        <BackgroundMusic />
      </div>
    </BrowserRouter>
  );
}

/*
  Scroll the window to the top whenever the route changes, so navigating to
  a new page (via any button/link) always starts at the top.
*/
function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

/*
  Floating AI widgets (assistant + chatbot). Hidden on the delivery-partner
  portal — partners shouldn't see the customer shopping assistant.
*/
function FloatingWidgets() {
  const location = useLocation();

  if (location.pathname.startsWith('/delivery')) {
    return null;
  }

  return (
    <>
      <AssistantLauncher />
      <ChatBot />
      <NotificationLauncher />
      <MobileFabDial />
      <MobileBottomNav />
    </>
  );
}

export default App;
